module.exports = __webpack_public_path__ + "static/media/COS_NESTLE_NI_GUIGOZ.a4b181d5.webp";